/* Area02 品牌直播間 */

import type { ReactNode } from 'react'
import classnames from 'classnames/bind'

// Components
import SimpleHeader from './components/SimpleHeader'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

type BasicLayoutProps = {
  children: ReactNode
}

const Area02Layout = (props: BasicLayoutProps) => {
  const { children } = props

  return (
    <div id='layout' className={cx('layout')}>
      <SimpleHeader />

      <div className={cx('layout-body')}>{children}</div>
    </div>
  )
}

export default Area02Layout
